import React from "react";
import { ArrowLeft, RotateCw } from "lucide-react";

const LOGO = "/assets/logo.png";

const CheckoutCancel = () => (
  <div
    data-testid="checkout-cancel-page"
    className="min-h-screen bg-themed text-themed relative overflow-hidden flex items-center justify-center px-6"
  >
    <div className="absolute inset-0 gold-glow-radial pointer-events-none opacity-50" />
    <div className="absolute inset-0 noise-overlay pointer-events-none" />

    <div className="relative max-w-2xl text-center py-20">
      <div className="flex justify-center mb-10">
        <img
          src={LOGO}
          alt="Authentic Momentum"
          className="w-24 h-24 object-contain logo-mask opacity-80"
          draggable="false"
        />
      </div>

      <p className="text-[11px] tracking-[0.5em] uppercase text-gold mb-6">
        Checkout Paused
      </p>
      <h1 className="font-serif text-4xl sm:text-5xl text-themed leading-tight font-light">
        No payment was completed.
      </h1>
      <p className="mt-6 text-themed-muted leading-relaxed">
        You can return whenever you are ready to continue. Your moment is not
        going anywhere. Alignment unfolds in its own time.
      </p>

      <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
        <button
          data-testid="checkout-cancel-home"
          onClick={() => (window.location.href = "/")}
          className="btn-ghost-gold inline-flex items-center gap-2 justify-center"
        >
          <ArrowLeft size={13} /> Return Home
        </button>
        <button
          data-testid="checkout-cancel-restart"
          onClick={() => (window.location.href = "/?checkout=blueprint")}
          className="btn-gold inline-flex items-center gap-2 justify-center"
        >
          Start Again <RotateCw size={13} />
        </button>
      </div>
    </div>
  </div>
);

export default CheckoutCancel;
